import { on } from "@/neon/events";

export function loadReviews() {
  const { SPR } = window;

  if (SPR) {
    SPR.registerCallbacks();
    SPR.initRatingHandler();
    SPR.initDomEls();
    SPR.loadProducts();
    SPR.loadBadges();
  }
}

export default () => {
  // Reload reviews when a collection is filtered
  on("collection:updated", loadReviews);
};
